import { render, staticRenderFns } from "./SingPauseSchulenModal.vue?vue&type=template&id=1898d66a&"
import script from "./SingPauseSchulenModal.vue?vue&type=script&lang=js&"
export * from "./SingPauseSchulenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports